import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { ArrowL16, ArrowR16 } from '@cian/ui-kit/icons';
import classNames from 'classnames';
import * as styles from './Arrow.css';

interface IArrowProps {
  direction: TDirection;
  show: boolean;
  clickHandler?(direction: TDirection): void;
}

export const Arrow: React.StatelessComponent<IArrowProps> = props => {
  const { direction, show, clickHandler } = props;

  return (
    <div
      className={classNames(
        styles['click_area'],
        !show && styles['click_area--hidden'],
        direction < 0 && styles['click_area--left'],
      )}
      onClick={() => {
        return clickHandler && clickHandler(direction);
      }}
    >
      <div className={styles['background']}>
        <div className={styles['icon_container']}>
          {direction < 0 ? <ArrowL16 color={'gray_icons_100'} /> : <ArrowR16 color={'gray_icons_100'} />}
        </div>
      </div>
    </div>
  );
};
